/**
 * Grade Especial → SESSP → Dose Certa (padrão Inventários V2).
 * @param {object[]} records
 */
import { labelEsteira, formatDateTimeBr } from '../utils/dose-certa-labels.js';

function esc(s)
{
	if (s == null) return '';
	return String(s)
		.replace(/&/g, '&amp;').replace(/</g, '&lt;')
		.replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

export default async function (records)
{
	const statusLabel = {
		received: 'Na fila',
		processing: 'Processando',
		done: 'Promovido',
		error: 'Erro',
		rejected: 'Rejeitado',
	};
	const statusColor = {
		received: '#2563eb',
		processing: '#d97706',
		done: '#16a34a',
		error: '#dc2626',
		rejected: '#6b7280',
	};

	const rows = (records || []).map((r) => {
		const st = r.status || '';
		const color = statusColor[st] || '#333';
		const label = statusLabel[st] || st;
		const pct = Math.max(0, Math.min(100, Number(r.progress?.percent) || 0));
		const progLabel = r.progress?.label || '';
		const received = formatDateTimeBr(r.received_at);
		const programa = r.programa_nome
			? (r.programa && String(r.programa_nome) !== String(r.programa)
				? `${r.programa} — ${r.programa_nome}`
				: r.programa_nome)
			: (r.programa || '');
		const esteira = labelEsteira(r);
		const err = r.last_error ? String(r.last_error).slice(0, 80) : '';
		const idJson = JSON.stringify([r.company_id, r.id]);
		const saida = r.output_id
			? `<a href="#outputs" class="dc-open-output" data-company="${esc(r.company_id)}" data-output="${esc(r.output_id)}" title="Abrir Saídas filtrada nesta saída">#${esc(r.output_id)}</a>`
			: '—';
		const onda = r.wave_id
			? `<a href="#picking-waves" class="dc-open-wave" data-company="${esc(r.company_id)}" data-wave="${esc(r.wave_id)}" title="Abrir Derrubada — ondas filtrada nesta onda">#${esc(r.wave_id)}</a>`
			: '—';
		return `
		<tr data-id='${idJson}'>
			<td><input type="checkbox"></td>
			<td>${esc(received)}</td>
			<td>${esc(programa)}</td>
			<td>${esc(r.numero_pedido || '')}</td>
			<td>${esc(r.numero_fatura || '')}</td>
			<td>${esc(r.rota || '—')}</td>
			<td>${esc(r.destinatario || '—')}</td>
			<td>${r.item_count ?? 0}</td>
			<td style="color:${color}; font-weight:600;">${esc(label)}</td>
			<td>${esc(esteira)}</td>
			<td>
				<div style="font-weight:600;">${pct}%</div>
				<div class="dc-grid-progress"><span style="width:${pct}%;"></span></div>
				<small style="color:#64748b;">${esc(progLabel)}</small>
			</td>
			<td>${onda}</td>
			<td>${saida}${err ? `<br><small style="color:#dc2626;">${esc(err)}</small>` : ''}</td>
		</tr>`;
	}).join('');

	return `
		<style>
			.view th:nth-child(1) { width:1rem; }
			.view td:nth-child(8) { text-align:right; width:3.5rem; }
			.view td:nth-child(11) { text-align:center; }
			.dc-grid-progress { height: 7px; background:#e5e7eb; border-radius:999px; overflow:hidden; min-width:7rem; margin:2px auto; }
			.dc-grid-progress span { display:block; height:100%; background:#16a34a; }
			.dc-counts-hint { color:#64748b; font-size:.76rem; margin:4px 0 6px; }
			a.dc-open-output, a.dc-open-wave { color:#1e3a5f; font-weight:700; text-decoration:underline; }
			a.dc-open-output:hover, a.dc-open-wave:hover { color:#2563eb; }
		</style>
		<div class="dc-counts-hint">
			Cada linha é um <b>pedido/fatura</b> do TechHub. Clique na linha para o detalhe do pacote;
			no link da <b>Onda</b> abre a tela Derrubada já filtrada e no da <b>Saída</b> abre a tela Saídas já filtrada.
			Use <b>Filtrar</b> (empresa, programa, rota, destinatário, etc.).
		</div>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar seleções"></th>
					<th>Recebido</th>
					<th>Programa</th>
					<th>Pedido</th>
					<th>Fatura</th>
					<th>Rota</th>
					<th>Destinatário</th>
					<th>Itens</th>
					<th title="Situação do pacote no SIAL (fila TechHub → promovido / erro)">Status</th>
					<th title="Andamento na esteira BHT (Pendente → Enviado → Conferido) ou Coletor">Esteira</th>
					<th>Progresso</th>
					<th title="Onda de derrubada gerada (clique para abrir a tela Derrubada já filtrada)">Onda</th>
					<th>Saída</th>
				</tr>
			</thead>
			<tbody>${rows}</tbody>
		</table>`;
}
